import '@/assets/styles/index.scss';
import '@/assets/styles/primeVue/partnersTheme.css';
import esPrimeVue from '@/locales/esPrimeVue.json';
import { createApp, markRaw } from 'vue';
import { createPinia, setActivePinia } from 'pinia';

import App from './App.vue';
import router from '@/router';
import auth from './config/auth';
import initializeSentry from '@/config/sentry';
import * as Sentry from '@sentry/vue';
import PrimeVue from 'primevue/config';
import Tooltip from 'primevue/tooltip';

import {
  apolloClient,
  apolloUploadClient,
} from '@/config/apolloClientConstructor';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { useFeatureFlagsStore } from '@/stores/featureFlagsStore';
import { createAnalytics } from '@/analytics/analyticsPlugin';
import { GtmDestination } from '@/analytics/destinations/GtmDestination';
import { DebugDestination } from '@/analytics/destinations/DebugDestination';
import { SentryDestination } from '@/analytics/destinations/SentryDestination';

const pinia = createPinia();
//  inject apollo to Pinia
pinia.use(({ store }) => {
  store.$apollo = markRaw({ apolloClient, apolloUploadClient });
});
pinia.use(Sentry.createSentryPiniaPlugin());
setActivePinia(pinia);

await useFeatureFlagsStore().fetchFlags();

const app = createApp(App);

app
  .use(router)
  .use(pinia)
  .use(auth)
  .use(PrimeVue, {
    locale: esPrimeVue,
  })
  .use(VueQueryPlugin)
  .use(
    createAnalytics({
      router,
      destinations: [
        new GtmDestination(),
        new SentryDestination(),
        new DebugDestination(),
      ],
    }),
  )
  .directive('tooltip', Tooltip);

initializeSentry(app, router);

app.mount('#app');
